export default {
  orders: [],
  pendents: 0,
  loaded: false,
}
